import { render, staticRenderFns } from "./Sot.vue?vue&type=template&id=704fceaf&scoped=true&"
import script from "./Sot.vue?vue&type=script&lang=js&"
export * from "./Sot.vue?vue&type=script&lang=js&"
import style0 from "./Sot.vue?vue&type=style&index=0&id=704fceaf&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "704fceaf",
  null
  
)

export default component.exports